export var ConnectionStates;
(function (ConnectionStates) {
    /// Подлючен
    ConnectionStates["CONNECTED"] = "connected.ok";
    /// Подключается
    ConnectionStates["CONNECTING"] = "connecting";
    /// Будет отключен
    ConnectionStates["WILL_DISCONNECT"] = "will.disconnect";
    /// Отключен
    ConnectionStates["DISCONNECTED"] = "disconnected";
    /// Частично подключен
    ConnectionStates["HALFCONNECTED"] = "halfconnected";
    /// Потеря соединения
    ConnectionStates["CONNECTION_LOST"] = "connection.lost";
})(ConnectionStates || (ConnectionStates = {}));
export var ConectionResultEnum;
(function (ConectionResultEnum) {
    ConectionResultEnum[ConectionResultEnum["DisConnected"] = 0] = "DisConnected";
    ConectionResultEnum[ConectionResultEnum["Connected"] = 1] = "Connected";
    ConectionResultEnum[ConectionResultEnum["Error"] = 2] = "Error";
    ConectionResultEnum[ConectionResultEnum["NeedActivation"] = 3] = "NeedActivation";
    ConectionResultEnum[ConectionResultEnum["AdditionalVerification"] = 4] = "AdditionalVerification";
    ConectionResultEnum[ConectionResultEnum["NeedChangePassword"] = 5] = "NeedChangePassword";
    ConectionResultEnum[ConectionResultEnum["InvalidBrandingKey"] = 6] = "InvalidBrandingKey";
})(ConectionResultEnum || (ConectionResultEnum = {}));
